// extracted by mini-css-extract-plugin
export default {"badge":"NotificationsButton_badge__DZmqt"};